import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Product_Hierarchy_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PRDH_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Product Hierarchy ID',   columnResourceName: 'colWbId',               alignment: HorizAlignment.Left}, domainOptions: {} },
    WB_PRD_HIER_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Hierarchy ID',           columnResourceName: 'colHierarchyId',        alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    WB_PRD_HIER_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Hierarchy Name',         columnResourceName: 'colHierarchyName',      alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_HIERARCHY_TYPE: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Hierarchy Type', columnResourceName: 'colHierarchyType',      alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    HIERARCHY_USAGE:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Hierarchy Usage',        columnResourceName: 'colHierarchyUsage',     alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_SET_ID:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group ID',       columnResourceName: 'colProductGroupId',     alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID',              columnResourceName: 'colSourceId',           alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
 }

var ProductHierarchySearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PRDH_ID',
        id_ui: 'WB_PRD_HIER_ID',
        name:  'WB_PRD_HIER_NAME'},


    searchProviderFields: vUI_Product_Hierarchy_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_ProductHierarchy_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var ProductHierarchySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Product Hierarchy",
    renderOptions: { ui5ResourceId: "ProductHierarchySearchChild" },

    profileFilter: [
        {profileFilterName: 'Id',       searchProviderFieldId: 'WB_PRD_HIER_ID',     renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'WB_PRD_HIER_NAME', renderOptions: { }},

    ],  // ISearchFields
    profileDisplayFields: [
        'WB_PRDH_ID','WB_PRD_HIER_ID','WB_PRD_HIER_NAME','PRODUCT_HIERARCHY_TYPE','HIERARCHY_USAGE','PRODUCT_GROUP_SET_ID','SOURCE_ID',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductHierarchySearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var ProductHierarchySearch: ISearch = {
    searchName: "Find ProductHierarchy",
    renderOptions: { ui5ResourceId: "ProductHierarchySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ProductHierarchySearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("ProductHierarchyBO", "ProductHierarchy", ProductHierarchySearch, "Product Hierarchy Search")

export {ProductHierarchySearch}